import { render, staticRenderFns } from "./JudgeLayout.vue?vue&type=template&id=7f40579b&"
import script from "./JudgeLayout.vue?vue&type=script&lang=js&"
export * from "./JudgeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports